import React, { useState } from 'react';
import { clsx } from 'clsx';

interface Tab {
  label: string;
  value: string;
  content: React.ReactNode;
}

interface TabProps {
  tabs: Tab[];
  defaultValue?: string;
}

export const TabbedContent: React.FC<TabProps> = ({ tabs, defaultValue }) => {
  const [activeTab, setActiveTab] = useState(defaultValue || tabs[0]?.value);

  return (
    <div className="w-full my-8">
      <div className="flex border-b border-border mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.value}
            onClick={() => setActiveTab(tab.value)}
            className={clsx(
              "px-6 py-2.5 text-sm font-medium transition-all relative",
              activeTab === tab.value 
                ? "text-primary hover:text-primary/80" 
                : "text-slate-500 hover:text-slate-900"
            )}
          >
            {tab.label}
            {activeTab === tab.value && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary rounded-full shadow-[0_-1px_4px_rgba(255,107,0,0.4)]" />
            )}
          </button>
        ))}
      </div>
      <div className="transition-opacity duration-300">
        {tabs.find((tab) => tab.value === activeTab)?.content}
      </div>
    </div>
  );
};
